var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('MenuH'),_c('Banner2'),_c('skills'),_c('div',{attrs:{"data-aos":"fade-up","data-aos-anchor-placement":"top-bottom"}},[_c('about-me')],1),_c('experience'),_c('Whatido'),_c('portfolio'),_c('contact')],1)}
var staticRenderFns = []

export { render, staticRenderFns }